module.exports = __webpack_public_path__ + "img/emitFacefilter03.48442e71.png";